import useMsftSolutions from '../../../hooks/useMsftSolutions';
import { Button } from '@tackle-io/platform-ui';
import { type SolutionsFromApiType } from '../SolutionsToSelectedSolutionsTransform';

/** temporary component for development and testing.
 *  remove this when the actual solution selector is implemented
 */
const TempSolutionsSelector = ({
  onAddSolutions,
  onClose,
  selectedIds,
}: {
  onAddSolutions: (solutions: SolutionsFromApiType) => void;
  onClose: () => void;
  selectedIds: SolutionsFromApiType[number]['solutionId'][];
}) => {
  const solutionsQuery = useMsftSolutions();

  const handleSelectSolution = (solution: SolutionsFromApiType[number]) => {
    onAddSolutions([solution]);
    onClose();
  };

  return (
    <div>
      {solutionsQuery.isLoading && <p>Loading...</p>}
      {solutionsQuery.isError && <p>Error: {solutionsQuery.error}</p>}

      <div
        style={{
          display: 'grid',
          gap: '16px',
          marginTop: '24px',
        }}
      >
        {solutionsQuery.data?.solutions.map((solution) => {
          const isSelected = selectedIds?.includes(solution.solutionId);
          return (
            <div
              key={solution.tackleId}
              style={{
                display: 'grid',
                gap: '0.5rem',
                borderBottom: '1px solid #ccc',
                padding: '1rem',
              }}
            >
              <b>{solution.name}</b>
              <div>id: {solution.solutionId}</div>
              <div>type: {solution.solutionType}</div>
              <div>publisherName: {solution.publisherName}</div>

              <Button
                disabled={isSelected}
                appearance="primary"
                variant="contained"
                onClick={() => handleSelectSolution(solution)}
              >
                {isSelected ? 'Already selected' : 'Select solution'}
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TempSolutionsSelector;
